<div *ngIf="givi?.productSku" class="p-b-5">
    <!-- SKU únicos -->
    <div *ngIf="givi.productSkuLength <= 40" class="font-h7 text-center">
        <span class="font-h6 font-bold">SKUs:</span>
        <div style="color: #753CFD;">
            <span class="font-medium" [innerHTML]="givi.productSku"></span>
        </div>
    </div>
    <!-- SKU multiples -->
    <div *ngIf="givi.productSkuLength > 40" class="font-h7 text-center">
        <span class="font-h6 font-bold">
            SKUs:
            <button class="btn btn-rounded btn-outline-primary btn-xs m-l-15" (click)="showSKUs(skuModal)"> <b>Ver más SKUs</b></button>
        </span>
        <div class="m-t-5" style="color: #753CFD;">
            <span class="font-medium" [innerHTML]="givi.productSku.substring(0, 40) + ' ...'"></span>
        </div>
    </div>
</div>



<ng-template #skuModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center m-b-8 m-t-8 m-l-10 font-h4">
                {{givi?.productName}}
            </div>
        </div>

        <div class="p-b-24">
            <span class="font-h7 font-bold">SKUs:</span>
            <div class="font-c1 m-l-25" [innerHTML]="givi.productSku"></div>
        </div>
    </div>
</ng-template>